export const WAREHOUSE_PERMISSIONS = {
    VIEW: 'WAREHOUSE_VIEW',
    CATALOG_VIEW: 'WAREHOUSE_CATALOG_VIEW',
    CATALOG_MANAGE: 'WAREHOUSE_CATALOG_MANAGE',
    DOCUMENT_VIEW: 'WAREHOUSE_DOCUMENT_VIEW',
    DOCUMENT_MANAGE: 'WAREHOUSE_DOCUMENT_MANAGE',
    DOCUMENT_CREATE: 'WAREHOUSE_DOCUMENT_CREATE',
    DOCUMENT_POST: 'WAREHOUSE_DOCUMENT_POST',
    DOCUMENT_CANCEL: 'WAREHOUSE_DOCUMENT_CANCEL',
    INVENTORY_VIEW: 'WAREHOUSE_INVENTORY_VIEW',
    INVENTORY_MANAGE: 'WAREHOUSE_INVENTORY_MANAGE',
    AUTOMATION_VIEW: 'WAREHOUSE_AUTOMATION_VIEW',
    AUTOMATION_MANAGE: 'WAREHOUSE_AUTOMATION_MANAGE',
    REPORTS_VIEW: 'WAREHOUSE_REPORTS_VIEW',
    REPORTS_EXPORT: 'WAREHOUSE_REPORTS_EXPORT',
    COST_VIEW: 'WAREHOUSE_COST_VIEW',
    SETTINGS_VIEW: 'WAREHOUSE_SETTINGS_VIEW',
    SETTINGS_MANAGE: 'WAREHOUSE_SETTINGS_MANAGE',
}

export const WAREHOUSE_ACTION_PERMISSIONS = [
    { key: WAREHOUSE_PERMISSIONS.CATALOG_MANAGE, label: 'Изменение сырья и рецептур' },
    { key: WAREHOUSE_PERMISSIONS.DOCUMENT_CREATE, label: 'Создание и изменение черновиков' },
    { key: WAREHOUSE_PERMISSIONS.DOCUMENT_POST, label: 'Проведение документов' },
    { key: WAREHOUSE_PERMISSIONS.DOCUMENT_CANCEL, label: 'Отмена проведённых документов' },
    { key: WAREHOUSE_PERMISSIONS.INVENTORY_MANAGE, label: 'Проведение инвентаризации' },
    { key: WAREHOUSE_PERMISSIONS.AUTOMATION_MANAGE, label: 'Настройка автоматических позиций' },
    { key: WAREHOUSE_PERMISSIONS.SETTINGS_MANAGE, label: 'Настройка склада и мест хранения' },
    { key: WAREHOUSE_PERMISSIONS.COST_VIEW, label: 'Просмотр себестоимости' },
    { key: WAREHOUSE_PERMISSIONS.REPORTS_EXPORT, label: 'Экспорт складских отчётов' },
]

export const hasWarehousePermission = (user = {}, permission) => {
    const role = String(user?.role || '').toUpperCase()
    const isOwner = Object.prototype.hasOwnProperty.call(user || {}, 'id_parent') && Number(user?.id_parent || 0) === 0
    if (role === 'SA' || isOwner) return true
    const access = Array.isArray(user?.accessPage) ? user.accessPage : []
    if (access.includes(permission)) return true
    if ([WAREHOUSE_PERMISSIONS.DOCUMENT_CREATE, WAREHOUSE_PERMISSIONS.DOCUMENT_POST, WAREHOUSE_PERMISSIONS.DOCUMENT_CANCEL].includes(permission) && access.includes(WAREHOUSE_PERMISSIONS.DOCUMENT_MANAGE)) return true
    return access.includes('WAREHOUSE') && String(permission).endsWith('_VIEW')
}
